import { render, staticRenderFns } from "./IndexPayShippings.vue?vue&type=template&id=3ab7f9e8&scoped=true"
import script from "./IndexPayShippings.vue?vue&type=script&lang=js"
export * from "./IndexPayShippings.vue?vue&type=script&lang=js"
import style0 from "./IndexPayShippings.vue?vue&type=style&index=0&id=3ab7f9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab7f9e8",
  null
  
)

export default component.exports